
import { Sidebar } from "primereact/sidebar";
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import UserService from "../../../../GlobalSetupComponents/Services/UserService";
import { roleIdProcurement } from "../../../../GlobalSetupComponents/Enum/RoleEnum";
import { showErrorToast } from "../../../../components/Constant/Notification";

const InputField = ({ label, name, type = "text", value, onChange, required = false, min }) => (
  <div className="grid grid-cols-12 gap-4 items-center mb-4">
  <div className="flex  col-span-4 text-sm font-medium text-gray-700">
    <label className="">{label}</label>
    {required && <span className="text-red-500">*</span>}
  </div>

    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      className="w-full p-2 border col-span-8 rounded-md input-focus"
      required={required}
      min={min}
    />
  </div>
);

const ProspectAcresAndCentsUnitForm = ({ unit, onSave, onCancel, propertyId , existingUnits }) => {

  const [sourceBy, setSourceBy] = useState([]);
  const [formData, setFormData] = useState({
    id: unit?.id || null, // Use null for new units, actual ID for existing units
    order: unit?.order || (existingUnits?.length + 1 || 1),
    unitNo: unit?.unitNo || "",
    sqft: unit?.sqft || "",
    ratePerSqft: unit?.ratePerSqft || "",
    ratePerCent: unit?.ratePerCent || "",
    ratePerGround: unit?.ratePerGround || "",
    ratePerAcres: unit?.ratePerAcres || "",
    roadFacing: unit?.roadFacing || unit?.roadFacingSide?.name || "",
    roadWidth: unit?.roadWidth || "",
    preferredLocationCharge: unit?.preferredLocationCharge || "",
    registrationCharge: unit?.registrationCharge || "",
    notes: unit?.notes || "",
    unitStatus: unit?.unitStatus?.name || "Available",
    propertyId: unit?.propertyId || propertyId || "",
    vendorGuideline: unit?.vendorGuideline || "",
    governmentGuideline: unit?.governmentGuideline || "",
    isLocallyCreated: unit?.isLocallyCreated || false, // Track if this is a locally created unit
  });

  // Update form data when unit prop changes
  React.useEffect(() => {
    if (unit) {
      setFormData({
        id: unit?.id || null,
        order: unit?.order || (existingUnits?.length + 1 || 1),
        unitNo: unit?.unitNo || "",
        sqft: unit?.sqft || "",
        ratePerSqft: unit?.ratePerSqft || "",
        ratePerCent: unit?.ratePerCent || "",
        ratePerGround: unit?.ratePerGround || "",
        ratePerAcres: unit?.ratePerAcres || "",
        roadFacing: unit?.roadFacing || unit?.roadFacingSide?.name || "",
        roadWidth: unit?.roadWidth || "",
        preferredLocationCharge: unit?.preferredLocationCharge || "",
        registrationCharge: unit?.registrationCharge || "",
        notes: unit?.notes || "",
        unitStatus: unit?.unitStatus?.name || "Available",
        propertyId: unit?.propertyId || propertyId || "",
        vendorGuideline: unit?.vendorGuideline || "",
        governmentGuideline: unit?.governmentGuideline || "",
        isLocallyCreated: unit?.isLocallyCreated || false,
      });
    }
  }, [unit, existingUnits, propertyId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.unitNo.trim()) {
          showErrorToast("Unit No. is required.");
          return;
        }

   
    const isEditingExistingUnit = unit?.id || unit?.localId;

    const parsedData = {
      ...formData,
      id: formData.id || null,
      sqft: parseFloat(formData.sqft) || 0,
      ratePerSqft: parseFloat(formData.ratePerSqft) || 0,
      ratePerCent: parseFloat(formData.ratePerCent) || 0,
      ratePerGround: parseFloat(formData.ratePerGround) || 0,
      ratePerAcres: parseFloat(formData.ratePerAcres) || 0,
      northDimension: String(formData.northDimension || ""),
      eastDimension: String(formData.eastDimension || ""),
      westDimension: String(formData.westDimension || ""),
      southDimension: String(formData.southDimension || ""),
      roadWidth: String(formData.roadWidth || ""),
      preferredLocationCharge: parseFloat(formData.preferredLocationCharge) || 0,
      registrationCharge: parseFloat(formData.registrationCharge) || 0,
      vendorGuideline: parseFloat(formData.vendorGuideline) || 0,
      governmentGuideline: parseFloat(formData.governmentGuideline) || 0,
      roadFacingSide: { id: "", name: formData.roadFacing },
      unitStatus: { id: "", name: formData.unitStatus },
      order: parseInt(formData.order) || 1,
      // For new units that haven't been saved to the server yet
      isLocallyCreated: !formData.id,
      // Preserve existing localId for locally created units or generate one for new units
      localId: unit?.localId || (!isEditingExistingUnit ? `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}` : undefined),
      // Preserve original identification for editing
      originalId: unit?.originalId || unit?.id,
      originalLocalId: unit?.originalLocalId || unit?.localId,
      // Flag to indicate this is an edit operation
      isEditing: isEditingExistingUnit,
    };

    onSave(parsedData);
  };


  return (
    <Sidebar
      visible={true}
      position="right"
      onHide={onCancel}
      style={{ width: "560px" }}
      header={
        <div className="flex items-center justify-between w-full">
          <span className="font-semibold text-lg text-customGreen">
            {(unit?.id || unit?.localId) ? "Edit Unit" : "Add Unit"} Info Details
            {/* {unit?.isLocallyCreated && (
              <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
                Local Draft
              </span>
            )} */}
          </span>
        </div>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4 p-4">
      
        <InputField 
          label="Plot No." 
          name="unitNo" 
          value={formData.unitNo} 
          onChange={handleChange} 
          required={true}
         
        />
        <InputField 
          label="Over All Area (in Sq.Ft)" 
          name="sqft" 
          type="number" 
          value={formData.sqft} 
          onChange={handleChange} 
        
          min="0" 
        />
        <InputField 
          label="Rate Per Sq.Ft" 
          name="ratePerSqft" 
          type="number" 
          value={formData.ratePerSqft} 
          onChange={handleChange} 
         
          min="0" 
        />

<InputField 
          label="Rate Per Cent" 
            name="ratePerCent"
          type="number" 
          value={formData.ratePerCent} 
          onChange={handleChange} 
         
          min="0" 
        />

<InputField 
          label="Rate Per Ground" 
            name="ratePerGround"
          type="number" 
          value={formData.ratePerGround} 
          onChange={handleChange} 
         
          min="0" 
        />
        <InputField 
          label="Rate Per Acre" 
            name="ratePerAcres"
          type="number" 
          value={formData.ratePerAcres} 
          onChange={handleChange} 
         
          min="0" 
        />
       
        <InputField 
          label="Road Facing" 
          name="roadFacing" 
          value={formData.roadFacing} 
          onChange={handleChange} 
        />
        {/* <InputField 
          label="Road Width" 
          name="roadWidth" 
          value={formData.roadWidth} 
          onChange={handleChange} 
        /> */}
        {/* <InputField 
          label="Preferred Location Charge" 
          name="preferredLocationCharge" 
          type="number" 
          value={formData.preferredLocationCharge} 
          onChange={handleChange} 
          min="0" 
        /> */}
        <InputField 
          label="Registration Charge" 
          name="registrationCharge" 
          type="number" 
          value={formData.registrationCharge} 
          onChange={handleChange} 
          min="0" 
        />
        <InputField 
          label="Vendor Guideline" 
          name="vendorGuideline" 
          type="number" 
          value={formData.vendorGuideline} 
          onChange={handleChange} 
          min="0" 
        />
        <InputField 
          label="Government Guideline" 
          name="governmentGuideline" 
          type="number" 
          value={formData.governmentGuideline} 
          onChange={handleChange} 
          min="0" 
        />
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            className="w-full p-2 border rounded-md focus:ring-customGreen focus:border-customGreen"
            rows="4"
          />
        </div>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-customGreen text-white rounded-md hover:bg-green-600"
          >
            {(unit?.id || unit?.localId) ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </Sidebar>
  );
};

export default ProspectAcresAndCentsUnitForm;